import { formatShortDateTimeDisplay, formatShortDateDisplay } from "@aderant/aderant-react-components";
import { DateField } from "aderant-conflicts-models";
import React from "react";
import { FieldWrapper } from "./FieldWrapper";

interface DateInformationProps {
    field: DateField;
}

const getFormattedDate = (hasTimeComponent: boolean, date: Date | null | undefined): string => {
    if (!date) {
        return "-";
    }
    
    try {
        return hasTimeComponent ? formatShortDateTimeDisplay(date) : formatShortDateDisplay(date);
    }
    catch {
        return date?.toString() || "-";
    }
};

export const DateInformation = (props: DateInformationProps): JSX.Element => {
    const {
        field: { displayFormat, fieldLabel, value, },
    } = props;
    
    // Check if time component needs to be displayed
    const hasTimeComponent = displayFormat === "DateTime";
    
    return (
        <FieldWrapper fieldLabel={fieldLabel}>
            {getFormattedDate(hasTimeComponent, value)}
        </FieldWrapper>
    );
};
//